(function(window, document) {
  'use strict';

  var googleAdsId = 'AW-405435968';

  function loadTrackingScript(src) {
    var firstScript = document.getElementsByTagName('script')[0];
    var tag = document.createElement('script');

    tag.async = true;
    tag.src = src;
    firstScript.parentNode.insertBefore(tag, firstScript);
  }

  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    var dataLayerName = l !== 'dataLayer' ? '&l=' + l : '';

    loadTrackingScript('https://www.googletagmanager.com/gtm.js?id=' + i + dataLayerName);
  }(window, document, 'script', 'dataLayer', 'GTM-NQBLHPF'));

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function() {
    window.dataLayer.push(arguments);
  };

  loadTrackingScript('https://www.googletagmanager.com/gtag/js?id=' + googleAdsId);
  window.gtag('js', new Date());
  window.gtag('config', googleAdsId);
}(window, document));
